import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _findIndexInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find-index";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as FieldComponents from "@Shared/components/sections/index";
import InternalNotesMixin from "@Broker/@Modules/clients/applications/application/select-options/internal-notes-mixin";
import ApplicationNotesTable from "./application-notes-table";
import { mapActions, mapGetters } from "vuex";
import { mapFields } from "@joandvgv/vuex-map-fields";
import { ADD_APPLICATION_GROUP, SAVE_CURRENT_APPLICATION } from "../../store/application-actions";
import { cloneDeep, flatten } from "lodash";
import { CURRENT_APPLICATION } from "../../store/application-getters";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "InternalNotes",
  title() {
    return this.$t("sidebar.sections.application.internal-notes");
  },
  components: _objectSpread(_objectSpread({}, FieldComponents), {}, {
    ApplicationNotesTable
  }),
  mixins: [InternalNotesMixin],
  props: {
    clientUsername: {
      required: true,
      validator: String
    },
    applicationId: {
      required: true,
      type: Number
    }
  },
  data() {
    return {
      newNote: {
        category: "",
        note: "",
        "user-details": "",
        "entry-date": ""
      },
      currentMortgageType: ""
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapGetters("ApplicationStore", [CURRENT_APPLICATION])), mapFields("AccountStore", ["userDetails"])), {}, {
    mortgageTypeOptions() {
      var _context, _context2;
      return _filterInstanceProperty(_context = _mapInstanceProperty(_context2 = this.CURRENT_APPLICATION["submission-details"]).call(_context2, sub => {
        const mortgageType = sub["submission-details"]["mortgage-type"];
        return mortgageType && {
          label: `${this.$t(`application-form.${mortgageType}`)} ${this.$t("global.doorr.mortgage")}`,
          value: mortgageType
        };
      })).call(_context, Boolean);
    },
    disabledSaveButton() {
      return !this.newNote.category || !this.newNote.note || !this.currentMortgageType;
    },
    submissionIndex() {
      var _context3;
      return _findIndexInstanceProperty(_context3 = this.CURRENT_APPLICATION["submission-details"]).call(_context3, sub => sub["submission-details"]["mortgage-type"] === this.currentMortgageType);
    },
    internalNotes() {
      var _context4;
      const {
        "submission-details": submissionDetails = {}
      } = this.CURRENT_APPLICATION;
      return _filterInstanceProperty(_context4 = flatten(_mapInstanceProperty(submissionDetails).call(submissionDetails, sub => {
        var _context5;
        const mortgageType = this.getMortgageType(sub);
        return _mapInstanceProperty(_context5 = sub.notes).call(_context5, (note, index) => _objectSpread(_objectSpread({}, note), {}, {
          expanded: false,
          mortgageType,
          index
        }));
      }))).call(_context4, note => note.note);
    }
  }),
  watch: {
    mortgageTypeOptions: {
      immediate: true,
      handler(options) {
        if (options.length === 1) {
          this.currentMortgageType = options[0].value;
        }
      }
    }
  },
  methods: _objectSpread(_objectSpread({}, mapActions("ApplicationStore", [ADD_APPLICATION_GROUP, SAVE_CURRENT_APPLICATION])), {}, {
    handleSubmit() {
      if (this.disabledSaveButton) return;
      this.newNote["user-details"] = this.userDetails;
      this.newNote["entry-date"] = this.$options.filters.moment(new Date());
      const index = this.submissionIndex;
      if (index !== -1) {
        this.ADD_APPLICATION_GROUP({
          what: cloneDeep(this.newNote),
          where: `['submission-details'][${index}]['notes']`
        });
        this.handleSave();
        this.cleanFields();
      }
    },
    handleSave() {
      this.SAVE_CURRENT_APPLICATION({
        applicationId: this.CURRENT_APPLICATION.applicationId,
        clientUsername: this.clientUsername
      });
    },
    cleanFields() {
      this.newNote = {
        note: "",
        category: ""
      };
      this.currentMortgageType = "";
    },
    goToMortgageDetails() {
      this.$router.push({
        name: "application",
        params: _objectSpread(_objectSpread({}, this.$route.params), {}, {
          currentTab: "mortgage-details"
        })
      });
    },
    getMortgageType(submission) {
      return submission["submission-details"]["mortgage-type"];
    }
  })
});